export enum HelpType {
  OData = 'odata',
  Methods = 'methods',
  Baq = 'baq',
  Efx = 'efx'
}
